define('app/controllers/login',['angular', 'app/services/shared'], function (angular) {
  var module = angular.module('app.login', ['app.shared'])

  // Login
  module.controller('LoginController', [
    '$rootScope',
    '$scope',
    '$http',
    '$route',
    '$compile',
    '$location',
    'sharedProperties',
    function ($rootScope, $scope, $http, $route, $compile, $location, sharedProperties) {
      var apiBaseUrl = sharedProperties.getApiBaseUrl()

      $scope.showProgress = false
      $scope.username = ''
      $scope.password = ''

      $scope.login = function () {
        $scope.showProgress = true
        $http.post(apiBaseUrl + 'auth/credentials?UserName=' + $scope.username + '&Password=' + $scope.password + '', {}, {withCredentials: true}).then(function (data) {
          $scope.error = false
          //console.log(data);
          $rootScope.userName = data.data.UserName;
          $location.url('/main')
        }, function errorCallback (errResponse) {
          $scope.error = true
          $scope.errorMessage = sharedProperties.getErrorMessage(errResponse)
        })
      }
    }
  ])

  return module
})
;
